import { ILomItem, ILomListItem } from "src/modules/loms/models";

export interface LomsStateInterface {
  loms: ILomListItem[];
  totalCount: number;
  lomDetail: ILomItem | undefined;
}

function state(): LomsStateInterface {
  return {
    loms: [],
    totalCount: 0,
    lomDetail: undefined,
  };
}

export default state;
